import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";
import {mapNotArchiveRequestsCuttingList} from "../../../../utils/orders/RequestsCuttingUtil";

const requestsCuttingServiceRestUrl = ordersServicesPath + '/organizations/requests-cutting'

export default class RequestsCuttingService {

    static async add(data) {
        return axios.post(requestsCuttingServiceRestUrl + "?materialEstimateUnitId=" + data, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllArchive() {
        return axios.get(requestsCuttingServiceRestUrl + '/archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllWithMaterialNotArchive() {
        const response = await axios.get(requestsCuttingServiceRestUrl + '/not-archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return {
            ...response,
            data: mapNotArchiveRequestsCuttingList(response.data),
        };
    }

    static async getAllWithMaterialNotArchiveTypeCalculation() {
        return axios.get(requestsCuttingServiceRestUrl + '/not-archive-calculation', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllWithMaterialByOptimizationId(optimizationId, isCalculation) {
        return axios.get(requestsCuttingServiceRestUrl
            + '/by-optimization-id?optimizationId=' + optimizationId
            + '&isCalculation=' + isCalculation, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllWithMaterialByPlanId(planId) {
        return axios.get(requestsCuttingServiceRestUrl + '/by-plan-id?planId=' + planId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(requestsCuttingServiceRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableStatus(id, requestsCuttingState) {
        return axios.patch(requestsCuttingServiceRestUrl + '/' + id + '/unable-status?requestsCuttingState=' + requestsCuttingState, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setOptimizationByIds(ids, optimizationId,  isCalculation = false) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        await axios.patch(requestsCuttingServiceRestUrl + '/set-optimization-by-ids'
            + '?optimizationId=' + optimizationId
            + '&isCalculation=' + isCalculation,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async deleteOptimizationByIds(ids, isCalculation) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        await axios.patch(requestsCuttingServiceRestUrl + '/delete-optimization-by-ids'
            + '?isCalculation=' + isCalculation,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async getAllByOrderIdWithMaterial(orderId) {
        return axios.get(requestsCuttingServiceRestUrl + '/by-order-id?orderId=' + orderId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}